export class WresponseWrapper{
     id ?: string;
     type ?: string;
     message ?: string;
     confirma ?: boolean;
     mensaje ?: string;
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/WresponseWrapper.model.ts